import { getPriceWithoutReduction } from "../helper/Calculation";
export const ROUTE_DOCUMENT = "documents";
//CAREFUL!!!: They must be the same as on the DB
export const rowTypes = {
    pricePosition: 1,
    title: 2,
    text: 3,
    subtotal: 4,
    pageBreak: 5
};
//CAREFUL!!!!: They must match the database
export const positionTypes = {
    salary: 1,
    material: 2,
    materialMachine: 3,
    operationMaterial: 4,
    tool: 5,
    other: 6,
    external: 7,
    external2: 8,
    external3: 9,
    external4: 10
};
export const conditionLevels = {
    system_groups: 0,
    group1: 1,
    group2: 2,
    additions: 3,
    //vatr: 4 !DO not use. It's protected
    afterVat: 5
};
//A list of option used for the dropdown menu
export let variantOptions = [
    {
        value: null,
        name: '-'
    },
    {
        value: 0,
        name: '1'
    },
    {
        value: 1,
        name: '2'
    },
    {
        value: 2,
        name: '3'
    },
    {
        value: 3,
        name: '4'
    },
    {
        value: 4,
        name: '5'
    },
    {
        value: 5,
        name: '6'
    }
];
export var SCROLL_TARGETS;
(function (SCROLL_TARGETS) {
    SCROLL_TARGETS["BASIC"] = "basic";
    SCROLL_TARGETS["ADDRESS"] = "address";
    SCROLL_TARGETS["OPENING"] = "opening";
    SCROLL_TARGETS["RAPPORT"] = "rapport";
    SCROLL_TARGETS["POSITION"] = "position";
    SCROLL_TARGETS["CONDITION"] = "condition";
    SCROLL_TARGETS["CLOSING"] = "closing";
    SCROLL_TARGETS["PRINTING"] = "printing";
    SCROLL_TARGETS["ATTACHMENTS"] = "attachments";
    SCROLL_TARGETS["FINALIZE"] = "finalize";
})(SCROLL_TARGETS || (SCROLL_TARGETS = {}));
export var GlobalDocumentViewMode;
(function (GlobalDocumentViewMode) {
    GlobalDocumentViewMode[GlobalDocumentViewMode["finalized"] = 0] = "finalized";
    GlobalDocumentViewMode[GlobalDocumentViewMode["blueprint"] = 1] = "blueprint";
})(GlobalDocumentViewMode || (GlobalDocumentViewMode = {}));
export var DocumentPositionsViewMode;
(function (DocumentPositionsViewMode) {
    DocumentPositionsViewMode[DocumentPositionsViewMode["position"] = 0] = "position";
    DocumentPositionsViewMode[DocumentPositionsViewMode["calculation"] = 1] = "calculation";
    DocumentPositionsViewMode[DocumentPositionsViewMode["extent"] = 2] = "extent";
})(DocumentPositionsViewMode || (DocumentPositionsViewMode = {}));
export function getDocumentPositionNameShort(documentPosition) {
    var div = document.createElement("div");
    div.innerHTML = documentPosition.name || "";
    return div.innerText.substring(0, 30);
}
/**
 * Get the calculation factor for the given index
 * @param index the target
 * @param calculationFactorGroup the factor group.
 * @returns the value.
 */
export function getFactorValueForIndex(index, calculationFactorGroup) {
    if (index < 0 || index > 9)
        throw Error;
    return calculationFactorGroup["calculationFactor" + index];
}
export function getPostFactorValueForIndex(index, calculationFactorGroup) {
    if (index < 0 || index > 9)
        throw Error;
    return calculationFactorGroup["postCalculationFactor" + index];
}
/**
 * Generate a key which is used for grouping positions.
 * @param documentPosition
 * @param documentCalculationFactorGroup
 * @returns the key
 */
export function generatedKeyForPosition(documentPosition, documentCalculationFactorGroup) {
    const price = getPriceWithoutReduction(documentPosition, documentCalculationFactorGroup);
    return (documentPosition.positionNr ? documentPosition.positionNr : Math.random().toString(36).slice(-6)) + documentPosition.documentVatSet + documentPosition.unit + documentPosition.isNetto + documentPosition.fkSystemPositionType + "-" + price.toString() + (documentPosition.factor ? documentPosition.factor.toString() : "") + (documentPosition.discount ? documentPosition.discount.toString() : "");
}
/**
 * Generate a key which is used for grouping positions in the usecase for the amount.
 * @param documentPosition
 * @returns the key
 */
export function generatedKeyForAmountCombination(documentPosition) {
    return (documentPosition.positionNr ? documentPosition.positionNr : Math.random().toString(36).slice(-6)) + documentPosition.unit + documentPosition.fkSystemPositionType;
}
export function getLabelForSystemPositionType(systemPositonTypeId, systemPositionTypes, fullLength = true) {
    if (systemPositonTypeId != null && systemPositionTypes) {
        let systemFoundType = systemPositionTypes.find((systemPositionType) => systemPositionType.id == systemPositonTypeId);
        if (fullLength) {
            return systemFoundType ? systemFoundType.defaultName : "";
        }
        else {
            return systemFoundType ? systemFoundType.defaultShortName : "";
        }
    }
    return "";
}
/**
 * Create auto generated numbers for all positions given.
 * @returns
 */
export function generateAutoNumbersAndApplyOrderIndex(positions) {
    let numbering = [0, 0, 0, 0, 0, 0];
    let currentLevel = 0;
    //Now we have to create the numbering
    for (let i = 0; i < positions.length; i++) {
        const position = positions[i];
        //Only apply on title and positions.
        if (position.fkSystemRowType > rowTypes.title) {
            //Set the original order index as well
            position.orderIndex = i;
            continue;
        }
        //Get the target level for this position
        const targetLevel = position.level ? position.level - 1 : currentLevel;
        //If the target level should be lower we must reset the rest of the counters.
        if (targetLevel < currentLevel) {
            for (let index = targetLevel + 1; index < numbering.length; index++) {
                numbering[index] = 0;
            }
        }
        //Get the rigth target
        currentLevel = targetLevel;
        //Increase the value
        numbering[currentLevel] += 1;
        //Apply the number to the position
        position.autoGeneratedPosNr = numbering.slice(0, currentLevel + 1).join(".");
        //Set the original order index as well
        position.orderIndex = i;
        //We must increase the level if we have a title
        if (position.level) {
            currentLevel = position.level;
        }
    }
}
